// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/workflow/approval-opinion/approval-opinion.scss
// module id = 2041
// module chunks = 50